module.exports = __webpack_public_path__ + "static/media/howardstcondos.ea4d95dc.jpg";